// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Util_Dom from "../../../util/Util_Dom.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Cta_Ds from "../../atom/Atom_Cta_Ds.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Particle_Css from "../../particle/Particle_Css.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";

function getSpacerHorizontalValue(style) {
  var match = Atom_Cta_Ds.view(Atom_Cta_Ds.make(style));
  return Particle_Screen_Ds.extractDefaultValue(Particle_Screen_Ds.map((function (spacer) {
                    var match = Particle_Spacer_Ds.view(spacer);
                    var inside;
                    switch (match.TAG | 0) {
                      case /* Inside */0 :
                          inside = match._0;
                          break;
                      case /* Outside */1 :
                          return 0;
                      case /* Both */2 :
                          inside = match._0.inside;
                          break;
                      
                    }
                    return Particle_Css.spacerSizeInsideValue(Belt_Option.getWithDefault(inside.left, "Zero")) + Particle_Css.spacerSizeInsideValue(Belt_Option.getWithDefault(inside.right, "Zero")) | 0;
                  }), match.spacer));
}

function approxItemWidth(label, ctaStyle) {
  var spacerValue = getSpacerHorizontalValue(Curry._1(ctaStyle, /* Default */1));
  return Math.imul(label.length, 12) + spacerValue | 0;
}

function getWidthForId(refRoot, id) {
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.map(refRoot, (function (ref) {
                        return Util_Dom.getElementSize(Caml_option.nullable_to_opt(ref.querySelector("#" + id)));
                      })), (function (param) {
                    return param.width;
                  })), 0) | 0;
}

function shrink(_linksVisible, _linksMore, _widthListItems, widthAvailable) {
  while(true) {
    var widthListItems = _widthListItems;
    var linksMore = _linksMore;
    var linksVisible = _linksVisible;
    var lastItem = Belt_Array.get(linksVisible, linksVisible.length - 1 | 0);
    var match = widthListItems < widthAvailable;
    if (lastItem === undefined) {
      return [
              linksVisible,
              linksMore
            ];
    }
    if (match) {
      return [
              linksVisible,
              linksMore
            ];
    }
    var newWidthListItems = widthListItems - lastItem.width | 0;
    if (newWidthListItems <= widthAvailable) {
      return [
              Belt_Array.slice(linksVisible, 0, linksVisible.length - 1 | 0),
              Belt_Array.concat([lastItem], linksMore)
            ];
    }
    _widthListItems = newWidthListItems;
    _linksMore = Belt_Array.concat([lastItem], linksMore);
    _linksVisible = Belt_Array.slice(linksVisible, 0, linksVisible.length - 1 | 0);
    continue ;
  };
}

function grow(_linksVisible, _linksMore, _widthListItems, widthAvailable) {
  while(true) {
    var widthListItems = _widthListItems;
    var linksMore = _linksMore;
    var linksVisible = _linksVisible;
    var firstMoreItem = Belt_Array.get(linksMore, 0);
    var match = widthListItems > widthAvailable;
    if (firstMoreItem === undefined) {
      return [
              linksVisible,
              linksMore
            ];
    }
    if (match) {
      return [
              linksVisible,
              linksMore
            ];
    }
    var newWidthListItems = widthListItems + firstMoreItem.width | 0;
    if (newWidthListItems >= widthAvailable) {
      return [
              linksVisible,
              linksMore
            ];
    }
    _widthListItems = newWidthListItems;
    _linksMore = Belt_Array.sliceToEnd(linksMore, 1);
    _linksVisible = Belt_Array.concat(linksVisible, [firstMoreItem]);
    continue ;
  };
}

var characterSize = 12;

export {
  getSpacerHorizontalValue ,
  characterSize ,
  approxItemWidth ,
  getWidthForId ,
  shrink ,
  grow ,
}
/* Util_Dom Not a pure module */
